<script setup lang="ts">
import BaseButton from '@/components/library/buttons/BaseButton.vue';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

defineProps<{
  showDialog: boolean;
  title: string;
}>();

defineEmits<{
  (e: 'close:dialog'): void;
}>();
</script>

<template>
  <Transition name="fade">
    <div
      v-if="showDialog"
      class="fixed inset-0 w-full h-full bg-black bg-opacity-50 duration-300 overflow-y-auto backdrop-filter z-50 flex items-center justify-center"
    >
      <dialog
        class="flex flex-col p-6 rounded-md transition-all duration-300 w-[99%] md:w-[70%] lg:w-[50%] max-w-[750px] 2xl:w-3/4"
      >
        <div class="flex justify-between items-center mb-4 gap-4">
          <h5 class="text-2xl break-words flex-1">{{ title }}</h5>
          <base-button
            class="border-2 !flex items-center justify-center text-neutral-500 border-neutral-500 h-10 w-10 text-lg rounded-full hover:bg-neutral-500 hover:text-white active:bg-neutral-500 active:text-white transition-all duration-300"
            @click="$emit('close:dialog')"
          >
            <font-awesome-icon :icon="['fr', 'xmark']" class="text-xl" />
          </base-button>
        </div>
        <slot />
      </dialog>
    </div>
  </Transition>
</template>
